<script lang="ts">
	import { slideIn } from '$lib/actions/slideIn';
	import Quote from '$lib/icons/quote.svelte';
	import Image from '$lib/storyblok/components/image.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { SbImage } from '$lib/storyblok/types';
	import type { ISbStoryData } from '@storyblok/js';
	import type { CardCategory } from './types';

	interface Props {
		content: ISbStoryData<{
			bg_color: string;
			quote: string;
			name: string;
			title: string;
			image: SbImage;
			category: CardCategory;
		}>['content'];
		delay?: number;
		threshold?: number;
	}

	let { content, delay = 900, threshold = 0.3 }: Props = $props();
</script>

<article
	use:editable={content}
	use:slideIn={{ delay, threshold }}
	class="block rounded-xl p-2 opacity-[0.01]"
	style="background-color: {content.bg_color || '#000000'};"
>
	<Image
		class="aspect-[154/103] w-full rounded-lg object-cover lg:aspect-[265/149]"
		src={content.image?.filename}
		alt={content.image?.alt}
		title={content.image?.title}
	/>
	<div class="px-1 pb-1 pt-3">
		<Quote class="mb-2 h-3 w-3 text-brown-1" />
		<h1 class="mb-2 text-[14px]/[160%] text-brown-1 lg:mb-4 lg:text-[16px]/[150%]">
			{content.quote}
		</h1>
		<p class="text-[12px]/[160%] text-brown-1 lg:text-[14px]/[160%]">
			{content.name}
		</p>
		<p class="text-[12px] text-brown-4 max-lg:leading-[160%]">
			{content.title}
		</p>
	</div>
</article>
